const customerOrderCardTemplate = document.querySelector('#order-card-template');

if (!customerOrderCardTemplate) return;

function getOrderCardDate(orderCard) {
  const orderCardDateEl = orderCard.querySelector('[data-order-card-date] .content');
  const orderDatePreFormat = orderCardDateEl?.textContent;

  let orderDate;

  const [day, month, year] = orderDatePreFormat.split('/');

  if (year) orderDate = new Date(`${year}-${month}-${day}`);

  return orderDate;
}

async function getTransactions() {
  const body = document.querySelector('body');
  const isLoggedIn = body.dataset.loggedIn === 'true';

  if (!isLoggedIn) return;

  const olMember = await Shopify.functions.getMember();

  if (olMember) {
    const transactions = await Shopify.functions.getTransactions();
    return transactions;
  }

  return null;
}

function renderInstoreOrder({ order, orderCard, orderCardsContainer }) {
  const orderCardClone = customerOrderCardTemplate.content.cloneNode(true);
  const orderId = order.header?.documentNumber.replace(/^0+/, '');
  const orderTotal = order.grossValue;
  const orderDate = new Date(order.header?.purchasedAt).toLocaleDateString('da-DK', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).replace(/\./g, "/");
  const orderItemsCount = order.items?.length;

  const cardIdEl = orderCardClone.querySelector('#order-card-id .content');
  cardIdEl.textContent = orderId;

  const cardDateEl = orderCardClone.querySelector('#order-card-date .content');
  cardDateEl.textContent = orderDate;

  const cardTotalEl = orderCardClone.querySelector('#order-card-price .content');
  cardTotalEl.textContent = orderTotal.toFixed(2) + ' kr';

  const cardItemsCountEl = orderCardClone.querySelector('#order-card-quantity .content');
  cardItemsCountEl.textContent = orderItemsCount;

  const cardProductListEl = orderCardClone.querySelector('#order-card-product-list');
  const cardProductTitle = orderCardClone.querySelector('.product-title');

  order.items.forEach((item, i) => {
    const title = item.name;
    const quantity = item.quantity;
    const price = item.grossValue;
    const productTitleEl = document.createElement('div');
    productTitleEl.classList.add('product-title', 'h9-bold', 'product-title');
    productTitleEl.innerHTML = `${title} <span class="lowercase">x</span> ${quantity} — ${price.toFixed(2)} kr`;
    cardProductListEl.appendChild(productTitleEl);
  });


  // append
  if (orderCard) orderCardsContainer.insertBefore(orderCardClone, orderCard);
  else orderCardsContainer.appendChild(orderCardClone);
}

function renderInstoreOrders({ webOrders, inStoreOrders }) {
  const orderCardsContainer = document.querySelector('[data-customer-orders]');
  const existingOrderCards = [...document.querySelectorAll('[data-order-card-container]')];

  inStoreOrders.forEach(order => {
    const instorePurchasedAt = new Date(order.header?.purchasedAt);
    let inserted = false;

    existingOrderCards.forEach(orderCard => {
      const existingOrderPurchaseDate = getOrderCardDate(orderCard);

      if (existingOrderPurchaseDate && !inserted) {
        // When inStorePurchase is newer add it before the existing order
        if (instorePurchasedAt > existingOrderPurchaseDate) {
          renderInstoreOrder({ order, orderCard, orderCardsContainer });
          inserted = true;
        }
      }
    });

    // If the order is older than all existing orders, add it at the end
    if (!inserted) renderInstoreOrder({ order, orderCardsContainer });
  });

  if (inStoreOrders?.length) {
    const instoreOrdersTitle = document.querySelector('.instore-orders-title');
    instoreOrdersTitle.classList.remove('hidden');
  }
}

async function displayInstoreOrders() {
  const customerTransactions = await getTransactions();

  let inStoreOrders = [];
  const webOrders = customerTransactions?.items?.filter(item => {
    const isWeborder = item.header?.labels.some(label => label.key == "WeborderNo");
    if (!isWeborder) inStoreOrders.push(item);
    return isWeborder;
  });

  inStoreOrders.sort((a, b) => {
    const dateA = new Date(a.header.purchasedAt);
    const dateB = new Date(b.header.purchasedAt);
    return dateB - dateA;
  });

  if (!inStoreOrders?.length) return; 

  renderInstoreOrders({ webOrders, inStoreOrders });
}

displayInstoreOrders();

